import { ListItem, ListItemButton, ListItemIcon, Typography, Box } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import CheckIcon from '@mui/icons-material/Check'
import type { PropertyOptionModel } from '@/generated/graphql.ts'

interface Select1OptionListItemProps {
  label?: string
  option: PropertyOptionModel
  onClick: () => void
  isSelected?: boolean
}

export function Select1OptionListItem({
  option,
  label,
  onClick,
  isSelected,
}: Select1OptionListItemProps) {
  return (
    <ListItem
      key={option.id}
      disablePadding
      secondaryAction={isSelected ? <CheckIcon color="success" /> : null}
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          px: '1rem',
          py: 0.5,
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <CircleIcon sx={{ color: option.color, fontSize: 16 }} />
        </ListItemIcon>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {label && (
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
          )}
          <Typography variant="body2">{option.value}</Typography>
        </Box>
      </ListItemButton>
    </ListItem>
  )
}
